import {useTranslation} from "react-i18next";
import {useLocation, useNavigate} from "react-router-dom";
import complete from "../../assets/img/complete.png";
import "../../css/mobile/MUserPayComplPg.css";
import withAuth from "../../auth/UserRouteAuth";
import React, {useEffect} from "react";
import axios from "../../services/axiosInstance";
import Lottie from "lottie-react";
import completePay from "../../assets/motion/completePay2.json";

const MUserPayComplPg = () => {
    const {t} = useTranslation();
    const location = useLocation();
    const data = location.state.data;
    const navigate = useNavigate();

    const orderDetailPgMove = (ordNum) => () => {
        navigate(`/UserMyOrderPg/${ordNum}`);
    };

    useEffect(() => {
        if (data) {
            const clickId = localStorage.getItem('bt_sub1');
            const adChannel = localStorage.getItem('bt_sub2');

            if (clickId && adChannel) {
                let channelType;
                let platformType;

                // ChannelType 추출
                if (adChannel.includes("google")) channelType = '1'
                else if (adChannel.includes("youtube")) channelType = '2'
                else if (adChannel.includes("facebook")) channelType = '3'
                else if (adChannel.includes("instagram")) channelType = '4'
                else if (adChannel.includes("naver")) channelType = '5'
                else if (adChannel.includes("tiktok")) channelType = '6'
                else if (adChannel.includes("threads")) channelType = '7'
                else if (adChannel.includes("twitter")) channelType = '8'
                else if (adChannel.includes("gpt")) channelType = '9'
                else if (adChannel.includes("gemini")) channelType = '10'
                else if (adChannel.includes("community")) channelType = '11'

                // PlatformType 추출(2면 모바일웹 : 웹)
                platformType = window.navigator.userAgent.includes('Mobi') ? '2' : '1';

                axios({
                    method: 'post',
                    url: '/channelLog/saveAdData',
                    data: {
                        clickId:clickId,
                        eventType: '1', // Purchase
                        channelType: channelType,
                        platformType: platformType,
                        paymentPrice: data.lastPrice
                    },
                }).then((res) => {
                    localStorage.removeItem('bt_sub1');
                    localStorage.removeItem('bt_sub2');
                    console.log("광고수익 기록성공 : ", res.data);
                }).catch((err) => {
                    console.log("광고수익 기록실패 : ", err)
                })
            }
        }
    }, [data]);

    console.log("data : ", )

    return (
        <div className={'m-a-user-pay-compl-page-container font-t-cont'}>
            <div className={'m-a-user-pay-compl-contents'}>
                <Lottie
                    animationData={completePay}
                    loop
                    autoplay
                    className="wd-300 ht-120 opa09"
                    style={{margin:"-20px"}}
                />
                <div className={'m-a-user-pay-compl-title'}>{t(`pcCont`)}</div> {/*결제가 성공적으로 완료되었습니다*/}
                <div className={'m-a-user-pay-compl-divider'}/>
                <div className={'m-a-user-pay-compl-row'}>
                    <div className={'m-a-user-pay-compl-label'}>{t(`modNum`)}</div> {/*주문번호*/}
                    <div className={'m-a-user-pay-compl-value font-b'}>{data && data?.orderNumber}</div>
                </div>
                <div className={'m-a-user-pay-compl-row'}>
                    <div className={'m-a-user-pay-compl-label'}>{t(`modPty`)}</div> {/*결제수단*/}
                    <div className={'m-a-user-pay-compl-value'}>
                       {
                                    data && data?.payWay === "PM00" ? t(`modNoBank`) :
                                        data?.payWay === "PM01" ? "Paypal" :
                                            data?.payWay === "PM02" ? "WechatPay" :
                                                data?.payWay === "PM03" ? "AliPay" :
                                                    data?.payWay === "PM04" ? t(`modPt`) :
                                                        data?.payWay === "PM05" ? t(`modDep`) :
                                                            data?.payWay === "PM06" ? "BtoragePay(Global)" :
                                                                data?.payWay === "PM07" ? "BtoragePay(Korean)" :
                                                                    data?.payWay === "PM08" ? "GlobalCard" :
                                                                        data?.payWay === "PM09" ? "KoreanPay" : null
                                }
                    </div>
                </div>
                <div className={'m-a-user-pay-compl-row font-c-default'}>
                    <div className={'m-a-user-pay-compl-label'}>{t(`pcWon`)}</div> {/*최종원화금액*/}
                    <div className={'m-a-user-pay-compl-value font-b'}>
                        {data && "\u20A9 " + data?.lastPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    </div>
                </div>
                {/*추후 결제수단이 PM01(페이팔)이나 PM06(비토리지페이)일 경우 출력*/}
                {data && (data?.payWay === "PM01" || data?.payWay === "PM06" || data?.payWay === "PM08") &&
                    <div className={'m-a-user-pay-compl-row font-c-default'}>
                        <div className={'m-a-user-pay-compl-label'}>{t(`pcFor`)}</div> {/*최종외화금액*/}
                        <div className={'m-a-user-pay-compl-value font-b'}>
                            <span style={{color: data?.lastForPrice > 0 || data?.payInfoDTO?.lastForPrice > 0 ? 'darkorange' : 'black'}}>
                            {data && (data?.payInfoDTO?.lastForPrice || data?.lastForPrice)}
                            </span>
                            <span className={'m-a-user-pay-compl-value pale'}>
                                &nbsp;{data && (data?.payInfoDTO?.forCurrency || data?.forCurrency)}
                            </span>
                        </div>
                    </div>
                }
            </div>
            <div className={'m-a-user-pay-compl-buttons'}>
                <div className={'m-a-user-pay-compl-button'}
                     onClick={() => navigate("/UserMyPg")}>{t(`hdMypg`)}</div>
                <div className={'m-a-user-pay-compl-button primary'}
                     onClick={orderDetailPgMove(data.orderNumber)}>{t(`modHeader`)}</div>
            </div>
        </div>
    )
}

export default withAuth(MUserPayComplPg);
